import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, {
      to: "/",
      exact: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_btn, {
          icon: "fa fa-home",
          flat: "",
          stretch: ""
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_separator, { vertical: "" }),
    _createVNode(_component_router_link, {
      to: `/clients/${_ctx.clientId}/albums`,
      exact: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_btn, {
          icon: "fa fa-address-book",
          label: "Digital Albums",
          stretch: "",
          flat: "",
          "no-caps": ""
        })
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_component_router_link, {
      to: `/clients/${_ctx.clientId}/posts`,
      exact: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_btn, {
          icon: "fa fa-images",
          label: "Social Posts",
          stretch: "",
          flat: "",
          "no-caps": ""
        })
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}